export enum DualToggleState {
  left,
  right,
}
